import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../../../../stores/hooks";
import {
  addEmptyValueIfNeeded,
  findOutputValueStringWithLimit,
} from "../../../../../ActivityGrid/ActivityGrid.helpers";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import * as S from "./style";
import { useTranslation } from "react-i18next";
import { useGenerateWebhookGroup } from "../../../GenerateWebhookGroup/generate-webhook-group.hook";

import type { ActionGroupProps } from "../../types";
import { ActionDetailsContainer } from "../common/ActionDetailsContainer";
import { useActionDetails } from "../../hooks/useActionDetails";
import { InputList } from "../common/InputList/InputList";
import { WithFindWrapper } from "../common/WithFindWrapper/WithFindWrapper";

export const GenerateLoopingWebhookGroup = observer<ActionGroupProps>(
  ({
    action,
    recordJobData,
    recordJobDataByDetailsId,
    recordJobIds,
    onRecordClick,
    onDetailsClick,
  }) => {
    const { t } = useTranslation();
    const { jobDetails } = useRootStore();
    const { status, errorMessage, actionLabel, selectedActionFallback } =
      useActionDetails(action);
    const { getSortedInputs, getInputValue, getOutputDatas } =
      useGenerateWebhookGroup(jobDetails.job.automation?.timezone);

    return (
      <ActionDetailsContainer
        label={actionLabel}
        status={status}
        errorMessage={errorMessage}
        onDetailsClick={onDetailsClick}
      >
        <WithFindWrapper
          recordJobData={recordJobData}
          recordJobDataByDetailsId={recordJobDataByDetailsId}
          recordJobIds={recordJobIds}
          onRecordClick={onRecordClick}
        >
          {({ recordJobData }) => {
            const inputs = getSortedInputs(recordJobData);

            return (
              <ActivityDetailsItem label={t("general.inputs")}>
                <InputList
                  inputs={inputs}
                  recordJobData={recordJobData}
                  jobDetails={jobDetails}
                  action={action}
                  getInputValue={getInputValue}
                  selectedActionFallback={selectedActionFallback}
                />
                <S.ResponseTitle>
                  {t("automation.action-test-available-fields")}
                </S.ResponseTitle>
                {getOutputDatas(recordJobData).map((output) => (
                  <ActivityDetailsItem
                    key={output.outputId}
                    label={output.outputLabel}
                  >
                    {addEmptyValueIfNeeded(
                      findOutputValueStringWithLimit(
                        output.outputId,
                        recordJobData?.outputData?.outputs ?? [],
                      ),
                    )}
                  </ActivityDetailsItem>
                ))}
              </ActivityDetailsItem>
            );
          }}
        </WithFindWrapper>
      </ActionDetailsContainer>
    );
  },
);
